import urlResolver from 'admin/utils/URLResolver';
import useSWRImmutable from 'swr/immutable';
import { EmInsightsData } from '../types';

interface EmInsightsHook {
  data: EmInsightsData;
  error: Error | null | undefined | unknown;
  loading: boolean;
}

export const useEmInsights = (
  classId: ClassId,
  examId: ExamId
): EmInsightsHook => {
  const { data, error } = useSWRImmutable(
    urlResolver.query('api:em-insights', {
      classId,
      examId,
    })
  );

  if (error) {
    console.error(error);
  }

  return {
    data,
    error,
    loading: !data && !error,
  };
};
